import React, {useEffect, useState} from 'react';
import {mediaService} from "../../jwt/_services/media/mediaService";
import ImagePickerWorker from "./ImagePickerWorker";
import {Spinner} from "reactstrap";
import PropTypes from "prop-types";

const ImagePicker = (props ) => {
    const [fbMediaConfig, setFbMediaConfig] = useState(null);
    const [mediaList, setMediaList] = useState(null);
    const app = props.app;
    const objectMedia = props.objectMedia;

    useEffect(() => {
        const  getFbMediaConfig = async ()=> {

            const dataRequest = {
                fbDataBase: {
                    id: app?.fbDataBase.id
                },
                className: props.className
            };
            const {data} = await mediaService.search(0,100,dataRequest);
            if(data){
                setFbMediaConfig(data);
            }
        }

        const groupper = (listMedia) => {
            const groupedMedia = listMedia.filtered.reduce((acc, media) => {
                const fieldCode = media.fieldCode || 'none';
                if (!acc[fieldCode]) {
                    acc[fieldCode] = [];
                }
                acc[fieldCode].push(media);
                return acc;
            }, {});
            setMediaList(groupedMedia);
        }

        const getMediaList = async () => {
            const listMedia = await props.baseMediaService.search({[props.className]: objectMedia.id});
            if(listMedia){
                groupper(listMedia);
            }
        }
        getFbMediaConfig();
        getMediaList();

    }, []);

        return (
            <div className={'side-section'}>
                { (!mediaList) && <div className='text-center'><Spinner/> <br/>Cargando media...</div> }
                <div className={objectMedia && mediaList ? 'horizontal-container' : ''}>
                    {
                        fbMediaConfig && mediaList && fbMediaConfig.map((item, i) => (
                            <ImagePickerWorker
                                key={item.id}
                                config={item}
                                service={props.service}
                                baseMediaService={props.baseMediaService}
                                parent={objectMedia}
                                isActive={true}
                                mediaList={mediaList[item.fieldCode]}
                                afterUpload={props.afterUpload}
                            />
                        ))
                    }
                    
                    {!objectMedia && <div>Para subir imágenes, debes crear primero el registro</div>}
                    {fbMediaConfig && fbMediaConfig.length === 0 && <div>No hay configuracion de media</div>}
                </div>
            </div>
        );
            
}

export default ImagePicker

ImagePicker.propTypes = {
    objectMedia: PropTypes.object,
    className: PropTypes.string.isRequired
}
